"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFeatureToEvent = exports.addFeatureToRouteSpan = exports.getFeatureFromPath = void 0;
const user_routes_1 = require("./user-routes");
const FEATURES = {
    ALERTS: 'alerts',
    ANALYTICS: 'analytics',
    ORDERS: 'orders',
    LONGHAUL: 'longhaul-orders',
    REPORTING: 'reporting',
    SETTINGS: 'settings',
    SHIPMENTS: 'shipments',
    RETAILER: 'retailer',
    PRODUCTS: 'facility-products',
    PROFILE: 'profile',
    INFORMATION: 'information',
    NOTIFICATIONS: 'notifications',
    CARRIER: 'carrier',
    FACILITY_ORDERS: 'facility-orders'
};
const FEATURE_ROUTES = Object.keys(user_routes_1.USER_ROUTES)
    .map(key => ({ path: user_routes_1.USER_ROUTES[key], feature: FEATURES[key] }))
    .sort((a, b) => b.path.length - a.path.length);
function getFeatureFromPath(value) {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//'))
        return 'other';
    const pathname = value.split(/[?#]/, 1)[0];
    const match = FEATURE_ROUTES.find(({ path }) => pathname === path || pathname.startsWith(`${path}/`));
    return match ? match.feature : 'other';
}
exports.getFeatureFromPath = getFeatureFromPath;
function getRequestPath(url) {
    if (typeof url !== 'string' || !url)
        return undefined;
    try {
        // A fixed base supports relative request URLs without reading the current page.
        const parsed = new URL(url, 'https://sentry.invalid');
        return ['https:', 'http:'].includes(parsed.protocol) ? parsed.pathname : undefined;
    }
    catch {
        return undefined;
    }
}
function explicitFeature(value) {
    return typeof value === 'string' && value.length > 0 ? value : undefined;
}
function addFeatureToRouteSpan(options) {
    return {
        ...options,
        attributes: {
            ...options.attributes,
            feature: explicitFeature(options.attributes?.feature) || getFeatureFromPath(options.name)
        }
    };
}
exports.addFeatureToRouteSpan = addFeatureToRouteSpan;
function addFeatureToEvent(event) {
    const routeFeature = getFeatureFromPath(event.transaction);
    // A scope tag may have changed while an earlier navigation was finishing.
    const transactionFeature = event.type === 'transaction' ? explicitFeature(event.contexts?.trace?.data?.feature) : undefined;
    const feature = transactionFeature || explicitFeature(event.tags?.feature) ||
        explicitFeature(event.contexts?.trace?.data?.feature) ||
        (routeFeature !== 'other' ? routeFeature : getFeatureFromPath(getRequestPath(event.request?.url)));
    // Captured event data keeps delayed transactions attributed to their original route.
    return { ...event, tags: { ...event.tags, feature } };
}
exports.addFeatureToEvent = addFeatureToEvent;
